<template >
  <a :href="prevWeek" >
    <i class="icon icon-chevron prev"></i>
  </a>
  <a :href="nextWeek" >
    <i class="icon icon-chevron next"></i>
  </a>
</template>

<script setup>

import {defineProps} from "vue";
import {getNextWeek, getPrevWeek} from "@/data/helpers/dates";
import {useRoute} from "vue-router";
import { computed } from 'vue';
const route = useRoute();


const props = defineProps({
  to: {
    type: String,
    required: true,
  },
});

const prevWeek = computed(() => {
  const prevWeekObj = getPrevWeek(route.query.week, route.query.year);
  return props.to + '?week=' + prevWeekObj.week + '&year=' + prevWeekObj.year;
});

const nextWeek = computed(() => {
  const nextWeekObj = getNextWeek(route.query.week, route.query.year);
  return props.to + '?week=' + nextWeekObj.week + '&year=' + nextWeekObj.year;
});

</script>

<style lang="scss" scoped>
i{
  &.icon{
    width: 50px;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    &.icon-chevron{
      background-size: cover;
      background-repeat: no-repeat;
      &.prev{
        background-image: url('../assets/chevron-left.svg');
      }
      &.next{
        background-image: url('../assets/chevron-right.svg');
      }
    }
  }
}
</style>